import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { TEST_CATEGORIES, TESTS, Items } from '../TestResults/TestsData';
import { TestCategory } from '../TestResults/CategoryModel';
import { ItemsModel } from '../TestResults/ItemsModel';
import { Test } from '../TestResults/TestModel';
import { MatTableDataSource } from '@angular/material/table';

import * as XLSX from 'xlsx';

import * as jspdf from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { environment } from 'environments/environment';

import * as pdfMake from '../../assets/pdfmake/pdfmake';
import  pdfFonts from '../../assets/pdfmake/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-LabReports',
  templateUrl: './LabReports.component.html',
  styleUrls: ['./LabReports.component.scss']
})
export class LabReportsComponent implements OnInit {
  selectedMonthsDates: Date[] = [];
  TestResultForm: FormGroup;
  ClientId: any;
  AllBranchs: any;
  categories: TestCategory[] = TEST_CATEGORIES;
  items: ItemsModel[] = Items;
  tests: Test[] = TESTS;
  filteredTests: Test[] = [];
  selectedCategoryId: number | null = null;
  UserInfo: any;
  availableDatesMonthes: Date[] = [];
  MonthsAndYearsBetweenDates: any[] = [];
  dataSource: any;
  displayedColumns: string[] = ['TestName', 'DateResult', 'Result', 'Note'];
  filteredData: any;
  originaldata: any[] = [];
  totalPass: any;
  totalFail: any;

  constructor(private _formBuilder: FormBuilder, public GeneralService: GeneralService,private datePipe:DatePipe) {
  

 // Get client data and creation date
 var clientdata = JSON.parse(localStorage.getItem('ClientData'));
 var createdate = this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;
 
 // Get start and end dates
 const rawStartDate = new Date(createdate);
 // Set to first day of the creation month
 const startDate = new Date(rawStartDate.getFullYear(), rawStartDate.getMonth(), 1);
 const endDate = new Date(); // Current date
 
 // Initialize arrays
 this.availableDatesMonthes = [];
 

 let current = new Date(startDate);
 while (current <= endDate) {
   this.availableDatesMonthes.push(new Date(current));
   current.setMonth(current.getMonth() + 1);
 }
console.log('Available Months:', this.availableDatesMonthes);



    this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));
    this.ClientId = this.UserInfo.clientid;
  }
  get fc() {
    return this.TestResultForm.controls;
  }
  ngOnInit() {
    this.initForm()
    this.GetAllBranchs()
  }

  onMonthsSelectionChange(event: any) {

    this.selectedMonthsDates = event;
    this.selectedMonthsDates = event.slice(0, 3);
    console.log('Selected dates:', this.selectedMonthsDates);
  }

  isMonthsDateDisabled(date: Date): boolean {
    return this.selectedMonthsDates.length >= 3 && !this.selectedMonthsDates.includes(date);
  }

  initForm() {
    this.TestResultForm = this._formBuilder.group({
      selectedMonthsDates: [[], Validators.required],
      ItemId: ['', Validators.required],
      CategoryId: ['', Validators.required],
      TestId: [''],
      Branch: ['', Validators.required],
      UserId: [this.UserInfo.id],
      ClientId: [this.ClientId]
    });

  }

  GetTestsByCatId(categoryId) {
    console.log(categoryId)
    this.TestResultForm.get('TestId').reset()
    this.filteredTests = this.tests.filter(test => test.categoryId === categoryId);
  }

  GetAllBranchs() {
    this.GeneralService.getBranchByClientId(this.ClientId).then(res => {
      this.AllBranchs = res;
    })
  }

  getMonthsAndYearsBetweenDates(dates) {
    let result = [];

    // Convert date strings to Date objects and sort them
    let sortedDates = dates.map(date => new Date(date)).sort((a, b) => a - b);

    // Handle edge case: if there are no dates or only one date
    if (sortedDates.length === 0) {
      return result;
    }

    // Initialize with the first date
    let startDate = new Date(sortedDates[0]);
    let endDate = new Date(startDate);

    // Iterate through the sorted dates to create month-year objects
    for (let i = 1; i < sortedDates.length; i++) {
      let currentDate = new Date(sortedDates[i]);

      // Check if currentDate is within the same month-year period as endDate
      if (currentDate.getMonth() === endDate.getMonth() && currentDate.getFullYear() === endDate.getFullYear()) {
        endDate = new Date(currentDate); // Update endDate to extend the period
      } else {
        // Generate month-year objects for the period from startDate to endDate
        while (startDate <= endDate) {
          result.push({ month: startDate.getMonth() + 1, year: startDate.getFullYear() });
          startDate.setMonth(startDate.getMonth() + 1);
        }

        // Update startDate and endDate for the next period
        startDate = new Date(currentDate);
        endDate = new Date(startDate);
      }
    }

    // Generate month-year objects for the last period
    while (startDate <= endDate) {
      result.push({ month: startDate.getMonth() + 1, year: startDate.getFullYear() });
      startDate.setMonth(startDate.getMonth() + 1);
    }

    return result;
  }


  GetTestResult() {



    this.MonthsAndYearsBetweenDates = this.getMonthsAndYearsBetweenDates(this.TestResultForm.get('selectedMonthsDates').value);

    this.GeneralService.getAllTestsMonths(this.TestResultForm.value, this.MonthsAndYearsBetweenDates)
      .then(data => {
        if (data.lenght != 0) {
          data = data.filter(array => array.length > 0);
          console.log(data);

          const mergedData = data.flat();

          // Step 2: Sort the merged array by DateResult
          mergedData.sort((a, b) => {
            // Convert DateResult to Date objects for accurate comparison
            const dateA = new Date(a.DateResult);
            const dateB = new Date(b.DateResult);
            return dateA.getTime() - dateB.getTime();
          });
          this.originaldata = mergedData;
          this.dataSource = new MatTableDataSource(mergedData);
        } else {
          this.GeneralService.fireEmpty();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle error
      });







  }




  applyFilter(filterValue: string) {
    // Trim and convert filter value to lowercase
    const trimmedFilterValue = filterValue.trim().toLowerCase();

    // Define custom filter predicate
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      // Check if filter value is present in any of the specified columns
      return (
        data.TestName.toLowerCase().includes(filter) ||
        data.DateResult.toLowerCase().includes(filter) ||
        data.Result.toLowerCase().includes(filter) ||
        data.Notes.toLowerCase().includes(filter)
      );
    };

    // Apply the filter
    this.dataSource.filter = trimmedFilterValue;
  }


  getTotalPass(): number {
    return this.dataSource.data.filter(item => item.Result === 'PASS').length;
  }

  getTotalFail(): number {
    return this.dataSource.data.filter(item => item.Result === 'FAIl').length;
  }
  Submit() {
    if (this.TestResultForm.status == "VALID") {
      this.GetTestResult()
    }
    else {
      this.TestResultForm.markAllAsTouched();
    }
  }

  // exportToExcel(): void {
  //   // Extract the table data
  //   const dataToExport = this.originaldata.map((item: any) => ({
  //     TestName: item.TestName,
  //     DateResult: item.DateResult,
  //     Result: item.Result,
  //     Note: item.Notes
  //   }));

  //   // Add the summary data as a new row
  //   dataToExport.push(
  //     { TestName:`Summary :    Total Pass : ${this.getTotalPass()} |   Total Fail : ${this.getTotalFail()}`, DateResult: "", Result: '', Note:'' }
  //   );

  //   // Convert JSON data to worksheet
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

  //   // Create a new workbook and add the worksheet
  //   const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

  //   const now = new Date();
  //   const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)

  //   // Convert time to 12-hour format with AM/PM
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const seconds = now.getSeconds();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
  //   const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;   
  //   const fileName = `TestResults_${formattedDate}(${formattedTime}).xlsx`;
  //   // Export the workbook to Excel file
  //   XLSX.writeFile(workbook, fileName);
  // }

  exportToExcel(): void {
    // Extract the table data
    const dataToExport = this.originaldata.map((item: any) => ({
      TestName: item.TestName,
      DateResult: item.DateResult,
      Result: item.Result,
      Note: item.Notes
    }));

    // Convert JSON data to worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

    // Add the summary data as a new row with merged cells
    const summaryRow = ['Summary:       Total Pass: ' + this.getTotalPass() + ' | Total Fail: ' + this.getTotalFail()];
    XLSX.utils.sheet_add_aoa(worksheet, [summaryRow], { origin: -1 });

    // Merge the cells for the summary row
    const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
    const summaryRowIndex = range.e.r + 1; // Get the index of the summary row
    worksheet['!merges'] = [
      ...(worksheet['!merges'] || []),
      XLSX.utils.decode_range(`A${summaryRowIndex}:D${summaryRowIndex}`)
    ];

    // Create a new workbook and add the worksheet
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const now = new Date();
    const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)

    // Convert time to 12-hour format with AM/PM
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
    const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;
    const fileName = `TestResults_${formattedDate}(${formattedTime}).xlsx`;
    // Export the workbook to Excel file
    XLSX.writeFile(workbook, fileName);
  }

  // exportToPDF(): void {
  //   const doc = new jspdf.jsPDF();
  //   // Prepare table data
  //   const tableData = this.originaldata.map((item: any) => [
  //     item.TestName,
  //     item.DateResult,
  //     item.Result,
  //     item.Notes
  //   ]);
  //   const summaryRow = [
  //     'Summary :', // Label cell
  //     `Total Pass : ${this.getTotalPass()}  |  Total Fail : ${this.getTotalFail()}`, // Summary data
  //     '', // Empty cell for alignment
  //     '', // Empty cell for alignment
  //   ];

  //   // Add table to PDF
  //   autoTable(doc, {
  //     head: [['Test Name', 'Date Result', 'Result', 'Notes']], // Table headers
  //     body: [...tableData], // Combine table data with summary row,
  //     foot: [summaryRow],
  //     footStyles: { fillColor: [230, 230, 250], textColor: [0, 0, 0] },
  //     startY: 10, // Starting position on the Y axis
  //     margin: { horizontal: 10 }, // Margins
  //     styles: { fontSize: 10 }, // Font size
  //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }, // Header styles
  //     theme: 'striped', // Optional: adds alternating row colors
  //   });

  //   const now = new Date();
  //   const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)

  //   // Convert time to 12-hour format with AM/PM
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const seconds = now.getSeconds();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
  //   const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${ampm}`;
  //   console.log(formattedTime)
  //   const fileName = `TestResults_${formattedDate}(${formattedTime}).pdf`;

  //   // Save the PDF
  //   doc.save(fileName);
  // }



  // exportToPDF(): void {
  //   const doc = new jspdf.jsPDF();
    
  //   let imagelogo
  //   console.log(localStorage.getItem("ClientLogo"))
  //   if (localStorage.getItem("ClientLogo")) {
  //     imagelogo = localStorage.getItem("ClientLogo")
  //   }
  //   else {
  //     imagelogo =environment.logoBase64
  //   }    
  //   // Set image size to 30x30 mm
  //   const imageSize = 30;
  
  //   // Center the image horizontally on the page (doc.internal.pageSize.width gives the page width)
  //   const imageX = (doc.internal.pageSize.width - imageSize) / 2;
  //   const imageY = 10; // Place image 10mm from the top (adjust as necessary)
    
  //   // Add image to the header of the PDF (centered and 30x30 mm size)
  //   doc.addImage(imagelogo, 'PNG', imageX, imageY, imageSize, imageSize);
  
  //   // Prepare table data
  //   const tableData = this.originaldata.map((item: any) => [
  //     item.TestName,
  //     item.DateResult,
  //     item.Result,
  //     item.Notes
  //   ]);
    
  //   const summaryRow = [
  //     'Summary :', // Label cell
  //     `Total Pass : ${this.getTotalPass()}  |  Total Fail : ${this.getTotalFail()}`, // Summary data
  //     '', // Empty cell for alignment
  //     '', // Empty cell for alignment
  //   ];
  
  //   // Add table to PDF (start the table after the image, with 10mm padding below the image)
  //   autoTable(doc, {
  //     head: [['Test Name', 'Date Result', 'Result', 'Notes']], // Table headers
  //     body: [...tableData], // Combine table data with summary row
  //     foot: [summaryRow],
  //     footStyles: { fillColor: [230, 230, 250], textColor: [0, 0, 0] },
  //     startY: imageY + imageSize + 10, // Table starts 10mm after the image
  //     margin: { horizontal: 10 }, // Margins
  //     styles: { fontSize: 10 }, // Font size
  //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }, // Header styles
  //     theme: 'striped', // Optional: adds alternating row colors
  //   });
  
  //   const now = new Date();
  //   const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)
  
  //   // Convert time to 12-hour format with AM/PM
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const seconds = now.getSeconds();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
  //   const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${ampm}`;
  //   console.log(formattedTime);
  //   const fileName = `TestResults_${formattedDate}(${formattedTime}).pdf`;
  
  //   // Save the PDF
  //   doc.save(fileName);
  // }
  



//   exportToPDF(): void {
//     const doc = new jspdf.jsPDF();
//     doc.addFont('Cairo-Regular.ttf', 'arabic', 'normal');
// doc.setFont('arabic');
//     // Define base64 image (replace with your actual base64 string)
//     let imagelogo
//     console.log(localStorage.getItem("ClientLogo"))
//     if (localStorage.getItem("ClientLogo")) {
//       imagelogo = localStorage.getItem("ClientLogo")
//     }
//     else {
//       imagelogo = environment.logoBase64
//     }   
//     // Create an image element to extract its natural width and height
//     const img = new Image();
//     img.onload = () => {
//       // Get the natural width and height of the image (in pixels)
//       const imgWidth = img.naturalWidth;  // Image width in pixels
//       const imgHeight = img.naturalHeight;  // Image height in pixels
      
//       // Convert pixels to mm (1 px = 0.264583 mm)
//       const imgWidthMM = imgWidth * 0.264583;
//       const imgHeightMM = imgHeight * 0.264583;
  
//       // Center the image horizontally
//       const imageX = (doc.internal.pageSize.width - imgWidthMM) / 2;
//       const imageY = 10; // You can adjust this value to control the distance from the top
  
//       // Add the image to the PDF in its original size, centered
//       doc.addImage(imagelogo, 'PNG', imageX, imageY, imgWidthMM, imgHeightMM);
      
//       // Prepare table data
//       const tableData = this.originaldata.map((item: any) => [
//         item.TestName,
//         item.DateResult,
//         item.Result,
//         item.Notes
//       ]);
      
//       const summaryRow = [
//         'Summary :', // Label cell
//         `Total Pass : ${this.getTotalPass()}  |  Total Fail : ${this.getTotalFail()}`, // Summary data
//         '', // Empty cell for alignment
//         '', // Empty cell for alignment
//       ];
  
//       // Add table to PDF (starts after the image, with 10mm padding below the image)
//       autoTable(doc, {
//         head: [['Test Name', 'Date Result', 'Result', 'Notes']], // Table headers
//         body: [...tableData], // Table data
//         foot: [summaryRow],
//         footStyles: { fillColor: [230, 230, 250], textColor: [0, 0, 0] },
//         startY: imageY + imgHeightMM + 10, // Start table 10mm after the image
//         margin: { horizontal: 10 }, // Margins
//         styles: { fontSize: 10 }, // Font size
//         headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }, // Header styles
//         theme: 'striped', // Optional: adds alternating row colors
//       });
  
//       const now = new Date();
//       const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)
  
//       // Convert time to 12-hour format with AM/PM
//       const hours = now.getHours();
//       const minutes = now.getMinutes();
//       const seconds = now.getSeconds();
//       const ampm = hours >= 12 ? 'PM' : 'AM';
//       const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
//       const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${ampm}`;
//       console.log(formattedTime);
//       const fileName = `TestResults_${formattedDate}(${formattedTime}).pdf`;
  
//       // Save the PDF
//       doc.save(fileName);
//     };
  
//     // Start loading the image
//     img.src = imagelogo;  // Trigger image load
//   }



exportToPDF(): void {
  let imagelogo: string;
  if (localStorage.getItem("ClientLogo")) {
    imagelogo = localStorage.getItem("ClientLogo")!;
  } else {
    imagelogo = environment.logoBase64;
  }

  const now = new Date();
  const formattedDate = now.toISOString().split('T')[0];

  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;

  const fileName = `TestResults_${formattedDate}(${formattedTime}).pdf`;

  // Table headers with background color
  const tableHeaders = [
    { text: 'Test Name', bold: true, alignment: 'center' },
    { text: 'Date Result', bold: true, alignment: 'center' },
    { text: 'Result', bold: true, alignment: 'center' }
  ];

  // Table data with Notes row
 // Table data with Notes row and alternating colors
const tableData = [];
this.originaldata.forEach((item: any, index: number) => {
  const rowColor = index % 2 === 0 ? '#ffffff' : '#f5f5f5';  // Alternate between white and light gray
  
  // Push the main data row
  tableData.push([
    { 
      text: this.reverseText(item.TestName), 
      alignment: 'center', 
      font: 'Cairo', 
      style: 'rtlStyle',
      fillColor: rowColor
    },
    { 
      text: this.reverseText(item.DateResult), 
      alignment: 'center', 
      font: 'Cairo', 
      style: 'rtlStyle',
      fillColor: rowColor
    },
    { 
      text: this.reverseText(item.Result), 
      alignment: 'center', 
      font: 'Cairo', 
      style: 'rtlStyle',
      fillColor: rowColor
    }
  ]);

  // If there are notes, push a notes row with the same background color
  if (item.Notes && item.Notes.trim() !== '') {
    tableData.push([
      { 
        text: this.reverseText(item.Notes), 
        colSpan: 3, 
        alignment: 'right', 
        font: 'Cairo', 
        style: 'rtlStyle',
        fillColor: rowColor,  // Same color as the parent row
        fontSize: 10
      },
      {}, 
      {}
    ]);
  }
});

  // Summary row with background color
  const summaryRow = [
    { text: 'Summary :', bold: true, alignment: 'right', fillColor: '#e6e6fa' },
    { text: `Total Pass : ${this.getTotalPass()} | Total Fail : ${this.getTotalFail()}`, colSpan: 2, alignment: 'center', fillColor: '#e6e6fa' },
    {}
  ];

  const fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf'
    },
    Cairo: {
      normal: 'Cairo-Regular.ttf',
      bold: 'Cairo-Regular.ttf'
    }
  };

  const documentDefinition = {
    content: [
      {
        image: imagelogo,
        width: 100,
        alignment: 'center',
        margin: [0, 10, 0, 20]
      },
      {
        table: {
          headerRows: 1,
          widths: ['auto', '*', '*'],
          body: [tableHeaders, ...tableData, summaryRow]
        },
        // layout: 'lightHorizontalLines', // This keeps the original light horizontal lines
        layout: {
          hLineWidth: function (i: number, node: any) {
            if (i === 0) return 0; // إخفاء الخط العلوي للهيدر
            if (i === 1) return 2; // جعل الخط السفلي للهيدر بولد
            
            const currentRow = node.table.body[i];
            const previousRow = node.table.body[i - 1];
        
            // إذا كان الصف الحالي Notes أو الصف السابق كان Data والصف الحالي Notes، اجعل الخط 0
            if ((currentRow && currentRow[0].colSpan === 3) || 
                (previousRow && previousRow[0] && previousRow[0].text && !previousRow[0].colSpan)) {
              return 0; // إخفاء الخط الفاصل بين البيانات والملاحظات
            }
            
            return 0.5; // باقي الخطوط العادية
          },
          vLineWidth: function (i: number, node: any) {
            return 0;  // إخفاء الخطوط العمودية
          },
          
        }
,                
        alignment: 'right',
        margin: [0, 0, 0, 10]
      }
    ],
    defaultStyle: {
      font: 'Cairo'
    },
    styles: {
      rtlStyle: {
        dir: 'rtl',
        fontSize: 12,
        alignment: 'right'
      },
      header: {
        fontSize: 14,
        bold: true
      }
    },
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [40, 40, 40, 40]
  };
  // const documentDefinition = {
  //   content: [
  //     {
  //       image: imagelogo,
  //       width: 100,
  //       alignment: 'center',
  //       margin: [0, 10, 0, 20]
  //     },
  //     {
  //       table: {
  //         headerRows: 1,
  //         widths: ['auto', '*', '*'],
  //         body: [tableHeaders, ...tableData, summaryRow]
  //       },
  //       layout: {
  //         hLineWidth: function(i: number, node: any) {
  //           // For the header line
  //           if (i === 0) return 1;
            
  //           // For the summary row line
  //           if (i === node.table.body.length - 1) return 1;
            
  //           // Get current and previous rows
  //           const currentRow = node.table.body[i];
  //           const previousRow = node.table.body[i - 1];
            
  //           // If current row is a notes row OR previous row exists and next row would be notes
  //           if ((currentRow && currentRow[0].colSpan === 3) || 
  //               (previousRow && currentRow && currentRow[0].text && currentRow[0].text.includes('تجربه'))) {
  //             return 0; // Remove line
  //           }
            
  //           return 0.5; // Default line width for other rows
  //         },
  //         vLineWidth: function(i: number, node: any) {
  //           return 0;  // No vertical lines
  //         },
  //         hLineColor: function(i: number, node: any) {
  //           return '#aaa';
  //         }
  //       },
  //       alignment: 'right',
  //       margin: [0, 0, 0, 10]
  //     }
  //   ],
  //   defaultStyle: {
  //     font: 'Cairo'
  //   },
  //   styles: {
  //     rtlStyle: {
  //       dir: 'rtl',
  //       fontSize: 12,
  //       alignment: 'right'
  //     },
  //     header: {
  //       fontSize: 14,
  //       bold: true
  //     }
  //   },
  //   pageSize: 'A4',
  //   pageOrientation: 'portrait',
  //   pageMargins: [40, 40, 40, 40]
  // };
  pdfMake.createPdf(documentDefinition, null, fonts).open({ imageCompression: 'FAST' });
}

isArabic(text: string): boolean {
  // Check if the text contains Arabic characters
  return /[\u0600-\u06FF]/.test(text);
}
reverseText(text: string): string {
  
  if (!this.isArabic(text)) {
    // Return the text unchanged if it's not Arabic
    return text;
  }
  const singleLineText = text.replace(/\n+/g, ' ').trim();

  // Normalize spaces
  const normalizedText = singleLineText.replace(/\s+/g, ' ');

  // Split the text into words
  const words = normalizedText.split(' ');

  // Reverse the order of words
  const reversedWords = words.reverse();

  // Join the reversed words back into a single line
  return reversedWords.join(' ');
}


  // exportToPDF(): void {
  //   const doc = new jspdf.jsPDF();
    
  //   // Define base64 image (use your actual base64 string here)
  //   let imagelogo
  //   console.log(localStorage.getItem("ClientLogo"))
  //   if (localStorage.getItem("ClientLogo")) {
  //     imagelogo = localStorage.getItem("ClientLogo")
  //   }
  //   else {
  //     imagelogo = environment.logoBase64
  //   }    
  //   // Add image to the header of the PDF (adjust X, Y, width, and height as needed)
  //   doc.addImage(imagelogo, 'PNG', 0, 0, 30, 30); // X, Y, Width, Height
    
  //   // Prepare table data
  //   const tableData = this.originaldata.map((item: any) => [
  //     item.TestName,
  //     item.DateResult,
  //     item.Result,
  //     item.Notes
  //   ]);
    
  //   const summaryRow = [
  //     'Summary :', // Label cell
  //     `Total Pass : ${this.getTotalPass()}  |  Total Fail : ${this.getTotalFail()}`, // Summary data
  //     '', // Empty cell for alignment
  //     '', // Empty cell for alignment
  //   ];
  
  //   // Add table to PDF
  //   autoTable(doc, {
  //     head: [['Test Name', 'Date Result', 'Result', 'Notes']], // Table headers
  //     body: [...tableData], // Combine table data with summary row
  //     foot: [summaryRow],
  //     footStyles: { fillColor: [230, 230, 250], textColor: [0, 0, 0] },
  //     startY: 70, // Adjust the starting Y position after the header image
  //     margin: { horizontal: 10 }, // Margins
  //     styles: { fontSize: 10 }, // Font size
  //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] }, // Header styles
  //     theme: 'striped', // Optional: adds alternating row colors
  //   });
  
  //   const now = new Date();
  //   const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)
  
  //   // Convert time to 12-hour format with AM/PM
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const seconds = now.getSeconds();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
  //   const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${ampm}`;
  //   console.log(formattedTime);
  //   const fileName = `TestResults_${formattedDate}(${formattedTime}).pdf`;
  
  //   // Save the PDF
  //   doc.save(fileName);
  // }
  





}




